  import { useNavigate } from "react-router-dom";
import MainContainer from "../../../layout/MainContainer";
import CategoryList from "../../../features/budgetIntelligence/manageCategories/categoryList";


const BudgetCategories = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Budget Categories</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Budget Categories
        </p>
      </div>

      <div className="cards">
        <CategoryList />
      </div>
    </>
  );
};

export default BudgetCategories;
